import { useEffect, useState, useRef } from "react";
import api from "@/lib/api";
import { ExternalLink } from "lucide-react";

export default function AdSlot() {
  const [ads, setAds] = useState([]);
  const [idx, setIdx] = useState(0);
  const trackedRef = useRef(new Set()); // ad_ids we've already impressed this session

  useEffect(() => {
    api.get("/ads").then(({ data }) => setAds(data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (ads.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % ads.length), 6000);
    return () => clearInterval(t);
  }, [ads.length]);

  const ad = ads[idx];
  // Track impression once per ad per mount
  useEffect(() => {
    if (!ad) return;
    if (trackedRef.current.has(ad.ad_id)) return;
    trackedRef.current.add(ad.ad_id);
    api.post(`/ads/${ad.ad_id}/track`, { event: "impression" }).catch(() => {});
  }, [ad]);

  if (!ad) return null;

  const onClick = () => {
    api.post(`/ads/${ad.ad_id}/track`, { event: "click" }).catch(() => {});
  };

  return (
    <a
      href={ad.cta_url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      data-testid={`ad-${ad.ad_id}`}
      className="block rounded-2xl overflow-hidden border border-slate-200/80 relative group"
      style={{ background: ad.bg }}
    >
      <div className="flex items-center justify-between gap-4 p-5 sm:p-6">
        <div>
          <div className="text-[10px] font-bold tracking-widest uppercase" style={{ color: ad.accent }}>Sponsored · Local business</div>
          <div className="font-heading text-lg sm:text-xl font-extrabold text-white mt-1">{ad.business}</div>
          <div className="text-sm text-white/80 mt-0.5">{ad.tagline}</div>
        </div>
        <div className="inline-flex items-center gap-1 text-xs font-bold px-3 py-2 rounded-full transition-transform group-hover:translate-x-0.5" style={{ background: ad.accent, color: ad.bg }}>
          Visit <ExternalLink size={12} />
        </div>
      </div>
    </a>
  );
}
